(function () {
  var SECTION_SELECTOR = '.oddit-section-pdp-specifications';

  function initSection(section) {
    var tabs = section.querySelectorAll('[data-tab-target]');
    var panels = section.querySelectorAll('[data-tab-panel]');
    if (!tabs.length || !panels.length) return;

    function scrollTabIntoView(tab) {
      var scroller = tab.parentNode;
      if (!scroller) return;
      var cRect = scroller.getBoundingClientRect();
      var tRect = tab.getBoundingClientRect();
      var tabCenter = tRect.left + tRect.width / 2;
      var scrollerCenter = cRect.left + cRect.width / 2;
      scroller.scrollBy({ left: tabCenter - scrollerCenter, behavior: 'smooth' });
    }

    function activate(target) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab-target') === target;
        tab.classList.toggle('oddit-section-pdp-specifications__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-panel') === target;
        panel.classList.toggle('oddit-section-pdp-specifications__panel--active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        if (target) activate(target);
        scrollTabIntoView(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (keys.indexOf(e.key) === -1) return;
        e.preventDefault();
        var tabsArr = Array.prototype.slice.call(tabs);
        var idx = tabsArr.indexOf(document.activeElement);
        if (idx === -1) idx = 0;
        var nextIdx = idx;
        if (e.key === 'ArrowRight') nextIdx = (idx + 1) % tabsArr.length;
        else if (e.key === 'ArrowLeft') nextIdx = (idx - 1 + tabsArr.length) % tabsArr.length;
        else if (e.key === 'Home') nextIdx = 0;
        else if (e.key === 'End') nextIdx = tabsArr.length - 1;
        var nextTab = tabsArr[nextIdx];
        if (nextTab) {
          nextTab.focus();
          var target = nextTab.getAttribute('data-tab-target');
          if (target) activate(target);
          scrollTabIntoView(nextTab);
        }
      });
    });
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();